
import Vue from "vue";
import { Component } from "vue-property-decorator";
import SectionWriter from "./SectionWriter/SectionWriter.vue";
import AIJobManager from "./AIJobManager/AIJobManager.vue";
import { singularityStore, uiStore } from "@/store/store";
import {
  replaceImagesInSectionWithAi,
  replaceImagesInSectionWithAiMutating
} from "@/futurelayer/images/main";
import defensiveCopy from "@/util/defensive-copy";

@Component({
  components: {
    SectionWriter,
    AIJobManager
  }
})
export default class SingularityDebugPanel extends Vue {
  generateSitemapPopulatePagesWithSectionsWriteContentAndUpdateImages() {
  }

  get siteState() {
    return singularityStore.siteStatus.siteState;
  }
  
  get aiServer() {
    return singularityStore.aiServer;
  }

  async replaceImagesInSectionWithAi() {
    const node = uiStore.activeElement;
    if (!node) {
      alert("no active node");
      return;
    }
    const result = await replaceImagesInSectionWithAi(
      node,
      new AbortController()
    );
    console.log("Result is:", result);
  }

  async replaceImagesInSectionWithAiMutating() {
    const node = uiStore.activeElement;
    if (!node) {
      alert("no active node");
      return;
    }

    const phantomNode = defensiveCopy(node);

    await replaceImagesInSectionWithAiMutating(
      phantomNode,
      new AbortController()
    );
    console.log("phantomNode after mutation:", phantomNode);
  }

  get backgroundGeneratingHeadersAndFooters() {
    return singularityStore.backgroundGeneratingHeadersAndFooters;

  }
}
